import { REGEXP_ONLY_DIGITS } from "input-otp"
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@nimbitlabs/ui"

interface PinInputProps {
  value: string
  onChange: (value: string) => void
  onComplete?: (value: string) => void
  disabled?: boolean
  error?: boolean
}

export function PinInput({ value, onChange, onComplete, disabled, error }: PinInputProps) {
  const handleChange = (newValue: string) => {
    onChange(newValue)
    if (newValue.length === 6 && onComplete) {
      onComplete(newValue)
    }
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <InputOTP
        maxLength={6}
        value={value}
        onChange={handleChange}
        pattern={REGEXP_ONLY_DIGITS}
        disabled={disabled}
      >
        <InputOTPGroup className="gap-2">
          <InputOTPSlot 
            index={0} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
          <InputOTPSlot 
            index={1} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
          <InputOTPSlot 
            index={2} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
          <InputOTPSlot 
            index={3} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
          <InputOTPSlot 
            index={4} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
          <InputOTPSlot 
            index={5} 
            className={`w-12 h-14 text-2xl font-bold border-2 rounded-lg transition-all bg-input text-foreground ${
              error 
                ? 'border-destructive bg-destructive/10' 
                : 'border-border/50 focus:border-primary focus:ring-2 focus:ring-primary/20'
            }`}
          />
        </InputOTPGroup>
      </InputOTP>
      <p className="text-sm text-muted-foreground text-center">
        Enter the 6-digit code sent to your email
      </p>
    </div>
  )
}
